// eslint-disable-next-line no-control-regex
const ANSI_ESCAPE_REGEX = /(\x9B|\x1B\[)[0-?]*[ -/]*[@-~]/g;

const stripAnsiColors = (stringToStrip: string): string => {
  return stringToStrip.replace(ANSI_ESCAPE_REGEX, '');
};

export default stripAnsiColors;
